import { ContentComponent, ContentComponents } from "theme/libs/wordpress/utils/cmsComponentHandlers";

import FlexiblePlaceholder from "theme/libs/wordpress/content/cmsPlaceholders/FlexiblePlaceholder";
import ModulesLoading from "./ModulesLoading";
import PropTypes from "prop-types";
/* eslint-disable camelcase */
import React from "react";
import ThreeColumnsPlaceholder from "theme/libs/wordpress/content/cmsPlaceholders/ThreeColumnsPlaceholder";
import TwoColumnsPlaceholder from "theme/libs/wordpress/content/cmsPlaceholders/TwoColumnsPlaceholder";
import loadable from "@loadable/component";
import HeroPlaceholder from "theme/libs/wordpress/content/cmsPlaceholders/HeroPlaceholder";

const TwoColumnsModule = loadable(() => import("theme/libs/wordpress/content/cmsLayouts/default/TwoColumnsLayout"), {
    fallback: <ModulesLoading />,
});

const ThreeColumnsModule = loadable(
    () => import("theme/libs/wordpress/content/cmsLayouts/default/ThreeColumnsLayout"),
    {
        fallback: <ModulesLoading />,
    },
);

const ProductPromotionModule = loadable(
    () => import("theme/libs/wordpress/content/cmsModules/default/ProductPromotion"),
    {
        fallback: <ModulesLoading />,
    },
);

const ArticleSliderModule = loadable(
    () => import("theme/libs/wordpress/content/cmsModules/default/ArticleSliderModule"),
    {
        fallback: <ModulesLoading />,
    },
);

const ImageModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/ImageModule"), {
    fallback: <ModulesLoading />,
});

const ImageModuleCS = loadable(() => import("theme/libs/wordpress/content/cmsModules/customerService/ImageModuleCS"), {
    fallback: <ModulesLoading />,
});

const NewsletterModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/NewsletterModule"), {
    fallback: <ModulesLoading />,
});

const ProductsPromotionModule = loadable(
    () => import("theme/libs/wordpress/content/cmsLayouts/default/ProductsPromotionLayout"),
    {
        fallback: <ModulesLoading />,
    },
);

const QuoteModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/QuoteModule"), {
    fallback: <ModulesLoading />,
});

const TextModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/TextModule"), {
    fallback: <ModulesLoading />,
});

const TextHeroModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/TextHeroModule"), {
    fallback: <ModulesLoading />,
});

const FAQModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/FAQModule"), {
    fallback: <ModulesLoading />,
});

const LinkListModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/LinkListModule"), {
    fallback: <ModulesLoading />,
});

const TwoColumnsLayoutArticle = loadable(
    () => import("theme/libs/wordpress/content/cmsLayouts/article/TwoColumnsLayoutArticle"),
    {
        fallback: <ModulesLoading />,
    },
);

const InformationLayout = loadable(() => import("theme/libs/wordpress/content/cmsLayouts/default/InformationLayout"), {
    fallback: <ModulesLoading />,
});

const VideoPlayerModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/VideoPlayerModule"), {
    fallback: <ModulesLoading />,
});

const CategorySlider = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/CategorySliderModule"), {
    fallback: <ModulesLoading />,
});

const ProductGrid = loadable(() => import("theme/libs/wordpress/content/cmsLayouts/default/ProductGrid"), {
    fallback: <ModulesLoading />,
});

const PageIntro = loadable(() => import("theme/libs/wordpress/content/cmsModules/article/PageIntroModule"), {
    fallback: <ModulesLoading />,
});

const ArticlePageIntro = loadable(
    () => import("theme/libs/wordpress/content/cmsModules/article/ArticlePageIntroModule"),
    {
        fallback: <ModulesLoading />,
    },
);

const ArticleHeroModule = loadable(() => import("theme/libs/wordpress/content/cmsModules/article/ArticleHeroModule"), {
    fallback: <ModulesLoading />,
});

const Iframe = loadable(() => import("theme/libs/wordpress/content/cmsModules/default/IframeModule"), {
    fallback: <ModulesLoading />,
});

const TeamMembersLayout = loadable(() => import("theme/libs/wordpress/content/cmsLayouts/default/TeamMembersLayout"), {
    fallback: <ModulesLoading />,
});

const DownloadDocumentsModule = loadable(
    () => import("theme/libs/wordpress/content/cmsModules/default/DownloadDocumentsModule"),
    {
        fallback: <ModulesLoading />,
    },
);

const YouTubePlayerModule = loadable(
    () => import("theme/libs/wordpress/content/cmsModules/default/YouTubePlayerModule"),
    {
        fallback: <ModulesLoading />,
    },
);

const ProductSliderModule = loadable(
    () => import("theme/libs/wordpress/content/cmsModules/default/ProductSliderModule"),
    {
        fallback: <ModulesLoading />,
    },
);

// Object of avalible modules/layouts and their keys
const availableContentComponents = {
    // Add the modules/layouts that exists in core/views directly in here.
    // We don't want to dynamically import them as that would cause circular references.

    // All default modules/layouts
    columns_two: TwoColumnsModule,
    columns_three: ThreeColumnsModule,
    flexible: FlexiblePlaceholder,
    product_promotion: ProductPromotionModule,
    "2_columns_module": TwoColumnsPlaceholder,
    "3_columns_module": ThreeColumnsPlaceholder,
    articles_slider_module: ArticleSliderModule,
    image_module: ImageModule,
    newsletter_module: NewsletterModule,
    products_promotion_module: ProductsPromotionModule,
    quote_module: QuoteModule,
    text_section: TextModule,
    faq_module: FAQModule,
    hero_placeholder: HeroPlaceholder,
    link_list_module: LinkListModule,
    video_player_module: VideoPlayerModule,
    // Custom modules/layouts for Articles
    article_page_intro_module: ArticlePageIntro,
    article_hero_module: ArticleHeroModule,
    page_intro_module: PageIntro,
    article_flexible_hero_module: FlexiblePlaceholder,
    flexible_hero_module: FlexiblePlaceholder,
    "2_columns_article_module": TwoColumnsLayoutArticle,
    "3_columns_article_module": ThreeColumnsPlaceholder,
    information_module: InformationLayout,
    image_article_module: ImageModule,
    image: ImageModule,
    products_promotion_article_module: ProductsPromotionModule,
    quote_article_module: QuoteModule,
    // 'video_player_article_module': VideoPlayerModule,
    // Custom modules/layouts for Customer Service
    image_cs_module: ImageModuleCS,
    faq_cs_module: FAQModule,
    category_slider_module: CategorySlider,
    product_grid: ProductGrid,
    page_intro: PageIntro,
    iframe_module: Iframe,
    text_hero: TextHeroModule,
    team_members: TeamMembersLayout,
    download_documents: DownloadDocumentsModule,
    youtube_player_module: YouTubePlayerModule,
    product_slider: ProductSliderModule,
};

/**
 * Accepts raw module data from the cms and tries to match the data to a cmsModule/cmsLayout.
 * If a match is found the cmsModule/cmsLayout is returned and rendered.
 * @param {(object|object[])} data - Raw module data from the cms. Can be a object or an array of objects.
 * @param {...*} rest - All additional props will be forwarded to the cmsModule/cmsLayout.
 */

const CmsModules = ({ data, ...rest }) => {
    if (!data) {
        return null;
    } else if (Array.isArray(data)) {
        return <ContentComponents data={data} availableContent={availableContentComponents} {...rest} />;
    }
    return <ContentComponent data={data} availableContent={availableContentComponents} {...rest} />;
};

CmsModules.propTypes = {
    data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
};

CmsModules.defaultProps = {
    data: undefined,
};

export default CmsModules;
